<template>

    <v-container class="pa-2" fluid grid-list-sm >   
        <v-layout row wrap v-if="content">
            <v-flex xs2>
                    <v-card>
                        <v-card-title>
                            {{content.chapter_name}}
                        </v-card-title>
                        <v-card-text>
                            <v-list shaped>
                                <v-list-item-group color="primary" v-model="lessonIndex">
                                <v-list-item
                                v-for="(lesson,index) in content.lesson_list"
                                :key="index"
                                @click="getLesson(index)"
                                >
                                    <v-list-item-icon>
                                        <v-icon v-if="(lesson.tasks_nonfinished == 0) && (lesson.programs_nonfinished == 0)" color="green"> emoji_emotions</v-icon>
                                        <v-icon v-if="(lesson.tasks_nonfinished > 0) || (lesson.programs_nonfinished > 0)" color="green"> panorama_fish_eye</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title>
                                        {{ lesson.lesson_name }}
                                        </v-list-item-title>
                                    </v-list-item-content>

                                </v-list-item>
                                </v-list-item-group>
                            </v-list>
                        </v-card-text>
                    </v-card>
            </v-flex>            
            <v-flex xs8 v-if="taskContent"> 
                        <v-card>
                        <v-card-title>                    
                          {{lesson_name}}
                           <v-tabs v-if="taskSelection.length > 0"
                                v-model="position"
                                >
                                
                                    <div v-for="(task, index) in taskSelection" :key="index">
                                        <v-tab @click="setDataForContent(index)">                            
                                            <v-icon :color="getColor(task.content)">{{getIcon(task.content)}}</v-icon>
                                        </v-tab>
                                    </div>                                              
                                </v-tabs>
                                
                        </v-card-title>
                        <v-card-text>
                            <v-layout row wrap>
                                <v-flex xs11>
                                    <div v-if="qContent && taskSelection.length == 0">
                                        <v-layout row wrap justify-center>   
                                            <v-icon color="primary" x-large>block</v-icon>    
                                        </v-layout>
                                    </div>

                                    <div v-if="qContent && taskSelection.length > 0">
                                        <v-layout row wrap :key="refreshKey">              
                                            <AContent v-if="qtype == 1" v-bind:dcontent='qContent' /> 
                                            <AType2 v-if="qtype == 2" v-bind:dcontent='qContent'/> 
                                            <AType3 v-if="qtype == 3" v-bind:dcontent='qContent'/> 
                                            <AType4 v-if="qtype == 4" v-bind:dcontent='qContent'/> 
                                            <AType5 v-if="qtype == 5" v-bind:dcontent='qContent'/> 
                                            <AType6 v-if="qtype == 6" v-bind:dcontent='qContent'/> 
                                            <AType7 v-if="qtype == 7" v-bind:dcontent='qContent'/> 
                                            <AType8 v-if="qtype == 8 || qtype == 9 || qtype == 10" v-bind:dcontent='qContent'/>                            
                                            <AType11 v-if="qtype == 11" v-bind:dcontent='qContent'/>
                                        </v-layout>
                                    </div>
                                </v-flex>
                                <v-flex xs1>
                                    <v-card>
                                        <v-card-text>
                                            <v-layout column justify-center>
                                                <v-icon v-if="taskSelection[position].content.score*2 >= taskSelection[position].content.max_score" @click.native="nextTask()" color="green" x-large class="function-icons">play_circle_outline</v-icon>
                                                <v-icon v-if="taskSelection[position].content.score*2 < taskSelection[position].content.max_score" color="grey lighten-1" x-large class="function-icons">play_circle_outline</v-icon>
                                                <v-icon v-if="getTryAgainEvent" @click.native="tryAgain()" color="red" x-large class="function-icons">replay</v-icon>
                                                <v-icon v-if="qtype!=1 && !getTryAgainEvent" @click.native="checkAnswer()" color="green" x-large class="function-icons">check_circle_outline</v-icon>
                                                <v-icon class="material-icons-outlined function-icons" large color="primary">speaker_notes</v-icon>                                
                                                <v-icon v-if="qtype!=1" @click="tryShowHelp()" large class="function-icons" color="orange">help_outline</v-icon> 
                                                <v-icon v-if="qtype!=1" @click="tryUnlock()" large class="function-icons" color="orange">lock_open</v-icon>
                                                <p></p>
                                                <h2 v-if="taskSelection[position].content.max_score >0" align = center>
                                                    {{taskSelection[position].content.score}}/{{taskSelection[position].content.max_score}}
                                                </h2>
                                                <h2 v-if="taskSelection[position].content.max_score == 0" align = center>
                                                    &nbsp;
                                                </h2>

                                            </v-layout>
                                        </v-card-text>
                                    </v-card>
                               </v-flex>
                            </v-layout>
                        </v-card-text>
                    </v-card>
        </v-flex>
        <v-flex xs2>
            <v-card v-if="!showMyHelp">
                <v-card-title style="background-color:orange">
                    <v-layout justify-center>
                    {{xp}} xp
                    </v-layout>
                </v-card-title>
                <v-card-text>
                    <p><span color=primary></span> </p>
                    <p>level: {{level}}</p>
                    <p>badges: </p>
                </v-card-text>

            </v-card>

            <v-card v-if="showMyHelp">
                <v-card-title>
                    <v-icon @click="showMyHelp = false" class="icon-close">close</v-icon>
                </v-card-title>
                <v-card-text>
                    <div v-if="qContent.data.content.help.length > 2" v-html="qContent.data.content.help">
                    </div>
                    <div v-if="qContent.data.content.help.length <= 2">
                        <v-layout row wrap justify-center>   
                            <p></p>
                            <v-icon color="primary" x-large>block</v-icon>    
                        </v-layout>
                    </div>
                </v-card-text>

            </v-card>

        </v-flex>

    </v-layout>

    <v-layout>
        <v-row justify="center">
            <v-dialog v-model="dialogHelp.show" persistent max-width="290">
            <v-card>
                <v-card-title class="headline">{{dialogHelp.title}}</v-card-title>
                <v-card-text v-html="dialogHelp.text"> 
                </v-card-text>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click="dialogHelp.show = false">Cancel</v-btn>
                <v-btn color="primary" text @click="buyAnything()">OK</v-btn>
                </v-card-actions>
            </v-card>
            </v-dialog>
        </v-row>
    </v-layout>

    <div v-if="getCheckRatingEvent">{{readRatingFromStore()}}</div>

    <div v-if="dialog" id="rateWindow"  >
       <v-card >
        <!--     <v-card-text> -->
                <v-rating
                v-model="rating"
                color="yellow darken-3"
                background-color=#eee
                empty-icon="$vuetify.icons.ratingEmpty"
                half-increments                                            
                size = 40
                readonly
            ></v-rating> 
                <p align="center"> 
                    <span v-if="showRating" >{{myScore}}</span>
                    <span v-if="!showRating" >{{rating/5*taskSelection[position].content.max_score}}</span>
                    /{{taskSelection[position].content.max_score}}
                </p>
         <!--    </v-card-text> -->
        </v-card>
    </div>
  

    </v-container>
</template>

<script>
import axios from '../../../../axios-auth.js'
import {mapGetters} from 'vuex'
import AContent from '../../../task_types/AContent.vue'
import AType2 from '../../../task_types/AType2.vue'
import AType3 from '../../../task_types/AType3.vue'
import AType4 from '../../../task_types/AType4.vue'
import AType5 from '../../../task_types/AType5.vue'
import AType6 from '../../../task_types/AType6.vue'
import AType7 from '../../../task_types/AType7.vue'
import AType8 from '../../../task_types/AType8.vue'
import AType11 from '../../../task_types/AType11.vue'

export default {
    data() {
        return {
            xp: 0,
            level: 0,
            content : null,
            lessons: null,
            drawer: true,
            mini: true,
            taskContent: null,
            taskSelection: [],  
            qtype : 0,
            qContent: null,
            refreshKey : 0,
            position: -1,
            lessonIndex: -1,
            lesson_name: null,
            filterType: 0,
            item : 2,
            showMyHelp: false,
            dialogHelp : {
                show: false,
                title: '',
                text: '',
                type: ''
            },
            dialog: false,
            rating: 0,
            myScore: 0,
            showRating : false
        }
    },
    components: {
        AContent,
        AType2,
        AType3,
        AType4,
        AType5,
        AType6,
        AType7,
        AType8,
        AType11
    },
    computed: 
        mapGetters([
                    'getCheckRatingEvent',
                    'getTryAgainEvent'
                ])
    ,
    mounted() {
        this.initData()
    },
    methods : {
        refreshChildComponent() {
            this.refreshKey += 1
        },
        initData() {
            this.$store.commit('setFeedback', null)    
            this.$store.commit('setBcChange',true)

            axios.get('/get-vpl-course-info/' + JSON.parse(localStorage.getItem('position')).activeCourse.id, this.$store.getters.getAxiosConfig )
                .then((res) => {
                    this.$store.commit('setEditorType',res.data.editorType)
                })
                .catch(error => {
                    this.$store.commit('setFeedback', error)
                })


            // get  list
            axios.get('/get-active-lessons/' + JSON.parse(localStorage.getItem('position')).activeCourse.id + '/' + this.$route.params.id, this.$store.getters.getAxiosConfig)
                .then(res => {
                    // set data to store
                    this.content = res.data 
                    // find nonfinished lesson
                    this.findNonFinishedLesson()
                    this.getLesson(this.lessonIndex)
                })
                .catch(error => {
                    this.$store.commit('setFeedback', error)
                })

            
            // get  xp
            axios.get('/get-user-xp', this.$store.getters.getAxiosConfig)
                .then((res) => {
                    // set data to store
                    this.loadXP(res)
                })
                .catch(error => {
                    this.$store.commit('setFeedback', error)
                })
        },
        getIcon(task) {
            if (task.task_type == 1 && task.first_time) return 'waves'
            if (task.task_type == 1 && !task.first_time) return 'playlist_add_check'

            if (task.task_type > 1 && task.task_type < 8 && task.first_time) return 'contact_support'
            if (task.task_type > 1 && task.task_type < 8 && task.passed) return 'thumb_up'
            if (task.task_type > 1 && task.task_type < 8 && !task.passed) return 'highlight_off'

            if (task.task_type > 7 && task.task_type < 12 && task.first_time) return 'play_circle_outline'
            if (task.task_type > 7 && task.task_type < 12 && task.passed) return 'check_circle'
            if (task.task_type > 7 && task.task_type < 12 && !task.passes) return 'error_outline'
        },
        getColor(task) {
            if (task.first_time) return 'primary'
            if (task.score == task.max_score) return 'green'
            if (task.score >= task.max_score/2) return 'orange'
            if (task.score < task.max_score/2) return 'red'
        },
        findNonFinishedLesson() {            
            for(let i = 0; i < this.content.lesson_list.length; i++) {
                if ((this.content.lesson_list[i].tasks_nonfinished > 0) || (this.content.lesson_list[i].programs_nonfinished > 0)) {
                    this.lessonIndex = i
                    return
                }
            }
            this.lessonIndex = this.content.lesson_list.length - 1
        },
        createTaskSelection(index) {
            this.filterType = index
            this.taskSelection = []
            for (let i = 0; i < this.taskContent.task_list.length; i++)
                  this.taskSelection.push({
                                    index : i,
                                    content: this.taskContent.task_list[i]
                                })
        },
        getLesson(index) {
            this.lessonIndex = index
            this.lesson_name = this.content.lesson_list[index].lesson_name

            this.$store.dispatch('setActiveLesson', {id: this.content.lesson_list[index].lesson_id, name: this.lesson_name})
            
            axios.get('/get-active-tasks/' 
                      + JSON.parse(localStorage.getItem('position')).activeCourse.id + '/'+
                      + JSON.parse(localStorage.getItem('position')).activeChapter.id + '/'+
                      + this.content.lesson_list[index].lesson_id
                      , this.$store.getters.getAxiosConfig)
                .then(res => {
                    // set data to store
                    this.taskContent = res.data 
                    // show all objects
                    this.createTaskSelection(0)
                    // get first non-finished-task
                    // search selection - if no return -1
                    let index = this.getNonFinishedTaskIndex()
                    if (index > -1) {
                        this.setDataForContent(index)
                    } else {
                        this.qContent = null
                    }
                })
                .catch(error => {
                    this.$store.commit('setFeedback', error)
                })

            
        },
        getNonFinishedTaskIndex() {
            for(let i = 0; i < this.taskSelection.length; i++) {
               if (this.taskSelection[i].score < this.taskSelection[i].max_score / 2) {
                   if (i > 0) { // set to content before question
                      if (this.taskSelection[i].task_type > 1 && this.taskSelection[i-1].task_type == 1) {
                          return i - 1
                      } else {
                          return i
                      }
                   } else {
                       return i
                   }
               }
            }
            // all content was passed
            if (this.taskSelection.length > 0) return 0
            else return -1 // not any content
        },
        setDataForContent(index) {
            if (this.taskContent == null) return
            this.$store.commit('setTryAgainEvent',false)
            if (index > this.taskContent.task_list.length-1) return
            this.refreshChildComponent()
            this.position = index
            this.qtype = this.taskContent.task_list[index].task_type

            var c = null
            var g = null
            if (this.qtype == 1) {
                c = this.taskContent.task_list[index].content
                g = this.taskContent.task_list[index].globals
                this.writeContent(index)
            } else {
                c = JSON.parse(this.taskContent.task_list[index].content)
                if ((this.qtype == 6) || (this.qtype == 7)) {
                    g = this.taskContent.task_list[index].globals
                }                
                else {
                    g = JSON.parse(this.taskContent.task_list[index].globals)
                }                
            }
            this.qContent = { data: {
                                    content: c,
                                    globals: g
                                },
                                task_id: this.taskContent.task_list[index].task_id,
                                score : Math.floor(0.5 + 100*this.taskContent.task_list[index].score/this.taskContent.task_list[index].max_score)
                            }
        },
        waitAMoment() {
            let t2 = setInterval(() => { clearInterval(t2)
                                            this.dialog = false 
                                            t2 = null}, 1500);
        },
        setRating(r) {
            var time = 100            
            this.showRating = false
            var timer
            if (r > 0) {
                this.rating = 0
                timer = setInterval(() => { if(this.rating == r) {
                                                    clearInterval(timer); 
                                                    timer = null
                                                    this.showRating = true
                                                    this.waitAMoment()
                                                } else {
                                                    this.rating += 0.5
                                                    }
                                                }, time);
            } else {
                this.rating = 5
                timer = setInterval(() => { if(this.rating == 0) {
                                                    clearInterval(timer); 
                                                    timer = null
                                                    this.showRating = true
                                                    this.waitAMoment()
                                                } else {
                                                    this.rating -= 0.5
                                                }
                                                }, time);                                                
            }            
        },
        taskAgain() {
            this.dialog = false
            this.refreshChildComponent()
        },
        nextTask() {
            this.dialog = false
            this.setDataForContent(this.position+1)
        },
        checkAnswer() {
            /* eslint-disable no-console */
            console.log('checkujem ')
            this.$store.commit('setCheckAnswerEvent',true)
        },
        readRatingFromStore() {
            this.$store.commit('setCheckRatingEvent',false)
            let rat = this.$store.getters.getAnswer.rating
            this.myScore = Math.floor(0.5 + rat/100 * this.taskSelection[this.position].content.max_score)
            this.rating = Math.floor(rat/10 + 0.5) / 2              // rating for stars
            this.writeAnswers(this.position, this.myScore) 
            this.dialog = true           
            this.setRating(this.rating) 
        },
        writeContent(index) {
            // local writing
            this.taskSelection[index].content.first_time = false            
            this.taskSelection[index].content.passed = true            
            this.taskContent.task_list[this.taskSelection[index].index].first_time = false
            this.taskContent.task_list[this.taskSelection[index].index].passed = true

            let _action = "show"
            // write to server
            const data = {
                "user_course_id" : this.content.user_course_id,
                "task_id" : this.taskSelection[index].content.task_id,
                "task_type_id" : this.taskSelection[index].content.task_type,
                "answer": "",
                "old_score": 0,
                "score" : 0,
                "max_score" : 0,
                "start_time" : "2019-10-09 16:43:01",
                "end_time" : "2019-10-09 16:45:55",
                "passed" : true,
                "help_showed" : false,
                "xp_add" : 0,
                "action": _action
            }
            axios.post('/write-user-task', data, this.$store.getters.getAxiosConfig)
                .then(() => {
                    //*************************************** */
                    
                })
                .catch(error => {
                    this.$store.commit('setFeedback', error)
                })            

        },
        writeAnswers(index, myscore) {
            // data preparation
            let _first_time = false            
            var _passed = false
            if (this.taskSelection[index].content.passed || (myscore >= this.taskSelection[index].content.max_score)
                || (this.taskSelection[index].content.score >= this.taskSelection[index].content.max_score)) {
                _passed = true
            } 
            // if user had some score from this task
            let _oldScore = this.taskSelection[index].content.score
            let _score = Math.round(Math.max(myscore, _oldScore))

            var _xp = 0
            if (this.taskSelection[index].content.first_time) {
                _xp = myscore
                if (myscore == this.taskSelection[index].content.max_score) _xp++  // reward
            } else {
                if (myscore > _oldScore) {
                    _xp = myscore - _oldScore
                }

            }
            _xp =  Math.round(_xp)
            let _answerDescription = this.$store.getters.getAnswer
            if (_answerDescription.solver == 'system') _xp = 0

            // to selection change score, passed, first_time
            this.taskSelection[index].content.passed = _passed
            this.taskSelection[index].content.score = _score
            this.taskSelection[index].content.first_time = _first_time            

            // to taskContent
            this.taskContent.task_list[this.taskSelection[index].index].passed = _passed
            this.taskContent.task_list[this.taskSelection[index].index].score = _score
            this.taskContent.task_list[this.taskSelection[index].index].first_time = _first_time            

            // to xp

            // ******************* writing ***************************
            // to server with details
            // - attempt is different from final
            // set answer - list of answers with status correct/incorrect  
            
            // count action
            var _action = "N/A"

            const data = {
                "user_course_id" : this.content.user_course_id,
                "task_id" : this.taskSelection[index].content.task_id,
                "task_type_id" : this.taskSelection[index].content.task_type,
                "answer": JSON.stringify(_answerDescription),
                "old_score": _oldScore,
                "score" : _score,
                "max_score" : this.taskSelection[index].content.max_score,
                "start_time" : "2019-09-20 16:43:01",
                "end_time" : "2019-09-20 16:45:55",
                "passed" : _passed,
                "help_showed" : this.taskSelection[index].content.help_showed,
                "xp_add" : _xp,
                "action": _action
            }

            axios.post('/write-user-task', data, this.$store.getters.getAxiosConfig)
                .then((res) => {
                    //*************************************** */
                    // read and show xp or level or badges
                    // console.log(res.data)
                    // read and show xp or level or badges
                    // console.log(res.data)
                    this.loadXP(res)
                })
                .catch(error => {
                    this.$store.commit('setFeedback', error)
                })
        },
        tryUnlock() {
            this.$store.commit('setTryAgainEvent',false)
            this.dialogHelp.type = 'answer'            
            this.dialogHelp.title = 'Do you want answer?'
            this.dialogHelp.text = '<p>Are you sure? Answer costs <b><span style="color:red">' + this.taskSelection[this.position].content.max_score * 2 +' xp</span></b>.</p>'            
            this.dialogHelp.show = true
        },
        tryShowHelp() {
            ////////////////////////////////////////////////////////////////////////////////////////////////////////////
            this.$store.commit('setTryAgainEvent',false)
            this.dialogHelp.type = 'help'
            this.dialogHelp.title = 'Do you want help?'
            this.dialogHelp.text = '<p>Are you sure?</p> <p>Help costs <b><span style="color:red"> ' + this.taskSelection[this.position].content.max_score +' xp</span></b>.</p>'            
            this.dialogHelp.show = true
        },
        buyAnything() {
            this.dialogHelp.show = false
            if (this.dialogHelp.type == 'answer') {
                this.$store.commit('setShowAnswerEvent',true)
            } else {
                this.showMyHelp = true
            }
        },
        tryAgain() {
            this.$store.commit('setTryAgainEvent',false)
            this.setDataForContent(this.position)
        },
        loadXP(res) {
            this.xp = res.data.xp
            this.level = res.data.level
        }

    }
}

</script>

<style src='vue-dialog-drag/dist/vue-dialog-drag.css'></style>

<style>
    .icon-close {
    position: absolute;
    top: 4px;
    right: 4px;
    cursor: pointer;
    }
    .function-icons {
      margin: 20px;  
    }
    #rateWindow {
        position: absolute;
        left: 50%;
        top: 50%;
        /* width: 15%; */
        transform: translate(-50%, -50%);
        
    }
    pre {
      font-weight: bold;
      background-color: gainsboro; 
      padding-left: 10px; 
      padding-bottom: 10px; 
      padding-top: 10px; 
    }
    p {
      padding-top: 5px; 
    }

</style>